import dayjs from 'dayjs'
import React from 'react'

import { Button } from '@fourthwall/components'
import { useFormikContext } from '@fourthwall/utils/dist/formik'

import { MuxPlayer } from '../../components/MuxPlayer'
import type { FormValues } from '../../types'
import { LiveStreamCountdown } from '../LiveStreamCountdown'
import * as S from './styled'

type Props = {
  rtmpsUrl: string
  srtUrl: string
  streamKey: string
  status: 'Disabled' | 'Idle' | 'Active'
  playbackId: string
  playbackToken: string
  isLoading: boolean
  onEndLiveStreamClick: () => void
  onStartLiveStreamClick: () => void
  onCountdownEnd: () => void
}

export const LiveStreamPreview = ({
  status,
  playbackId,
  playbackToken,
  rtmpsUrl,
  srtUrl,
  streamKey,
  isLoading,
  onEndLiveStreamClick,
  onStartLiveStreamClick,
  onCountdownEnd,
}: Props) => {
  const { values } = useFormikContext<FormValues>()

  const poster =
    typeof values.videoThumbnail === 'object'
      ? URL.createObjectURL(values.videoThumbnail as File)
      : values.videoThumbnail

  if (dayjs(values.liveStreamStartDate).isAfter(dayjs()) && status === 'Idle') {
    return (
      <LiveStreamCountdown
        rtmpsUrl={rtmpsUrl}
        srtUrl={srtUrl}
        streamKey={streamKey}
        startDate={values.liveStreamStartDate!}
        loading={isLoading}
        onCountdownEnd={onCountdownEnd}
      />
    )
  }

  if (dayjs(values.liveStreamStartDate).isAfter(dayjs()) && status === 'Active') {
    return (
      <LiveStreamCountdown
        playbackId={playbackId}
        playbackToken={playbackToken}
        startDate={values.liveStreamStartDate!}
        loading={isLoading}
        onStartClick={onStartLiveStreamClick}
        onCountdownEnd={onCountdownEnd}
      />
    )
  }

  return (
    <S.Container>
      <MuxPlayer
        playbackId={playbackId}
        tokens={{ playback: playbackToken }}
        streamType="live"
        poster={poster}
      >
        <S.ButtonContainer>
          <Button
            appearance="destructive"
            label="End livestream"
            loading={isLoading}
            onClick={onEndLiveStreamClick}
          />
        </S.ButtonContainer>
      </MuxPlayer>
    </S.Container>
  )
}
